const mapArrayToPromise = (array) => {
    if (array.some((item) => item instanceof Promise)) {
        return Promise.all(array);
    }
    return array;
};
export const mergeExperiments = (baseExperiments, experiments) => {
    const mappedExperiments = !experiments || experiments instanceof Promise
        ? experiments
        : mapArrayToPromise(experiments);
    if (baseExperiments instanceof Promise ||
        mappedExperiments instanceof Promise) {
        return Promise.all([baseExperiments, mappedExperiments]).then(([experiments1, experiments2]) => {
            return (experiments1 || []).concat(experiments2 || []);
        });
    }
    if (!baseExperiments && !mappedExperiments) {
        return undefined;
    }
    return (baseExperiments || []).concat(mappedExperiments || []);
};
//# sourceMappingURL=merge-experiments.js.map